export default "__VITE_ASSET__osa8fDrT__"